import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { InstructionService, AppService, DialogService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'
import { isArray } from 'lodash'
import { ConsultationSingleComponent } from '../../../content/consultation/consultation-single/consultation-single.component'

const KEY = 'panier-instruction-dialog'

@Component({
	selector: 'atyl-panier-instruction',
	templateUrl: './panier-instruction.component.html',
	styleUrls: ['./panier-instruction.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dialogs/instruction-personne-dialog',
	key: KEY,
})
export class PanierInstructionComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY)
	strings: any;
	instruction: any;
	professionnels: any;
	dossiers: any;
	iddossier: any;
	selectedInstructeur: any;
	comment: any;
	title: any;
	private debounce: Subject<string> = new Subject();
	selectedDemandeType: any;
	user: any;
	possibleTiers:any;
	selectedTiers:any;
	etape:any = [];
	options:any = [];

	tabTransi:any = [];
	instructionList = [];
	hasAtLeastOneInstructionNext = false;
	procedureList = [];
	proceduresToSend = [];
	proceduresToCancel = [];
	procedureTotal = 0;
	
	constructor(
		public dialogRef: MatDialogRef<PanierInstructionComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private appService: AppService,
		private instructionService: InstructionService,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		public dialog: MatDialog
	 
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		
		this.instruction = [];
		this.dossiers = [];
		this.iddossier = [];
		let max:any = 0;
		this.professionnels = [];
		let professions = [];
		let rang:any = 0;
		this.options = [];
		this.proceduresToSend = [];
		this.proceduresToCancel = [];
		this.procedureTotal = 0;
		let tab:any = [];

		if(this.data.origine == "etape"){
			this.dialogRef.updateSize("700px","")
		}
        if(this.data.user != undefined){
            this.user = this.data.user.id
        }
		if(this.data.donnees){
			for(let i=0;i<this.data.donnees.length;i++){
				if(this.data.donnees[i].instruction){
					this.instruction.push(this.data.donnees[i].instruction);
					this.instruction.map((i) => {
						this.professionnels.push({nom: i.instructeur.nom, prenom: i.instructeur.prenom});
					})
					this.professionnels = Object.values(this.professionnels.reduce((acc, {nom, prenom}) => {
						return {...acc, [`${nom}-${prenom}`]: {nom, prenom}}
					}, {}))
					this.dossiers.push(this.data.donnees[i].dossier);	

					if(this.user === undefined){
						this.user = this.data.donnees[i].user;
					}
					if (this.data.donnees[i].instruction.type 
					&& this.data.donnees[i].instruction.type.professions) {

						if(max < this.data.donnees[i].instruction.type.professions.length){

							max = this.data.donnees[i].instruction.type.professions.length;
							rang = i;
							this.iddossier = this.data.donnees[i].dossier.ID;

							this.data.donnees[i].instruction.type.professions.forEach(element => {
								professions.push(element.key);
							})
						}
					}
				} else {
					console.log("Cette ligne ("+this.data.donnees[i].dossier.NOM+' '+this.data.donnees[i].dossier.PRENOM+") ne comporte pas d'instruction, elle est donc ignorée")
				}
			}
			

			this.appService.getUsersByProfressions(professions, this.iddossier).subscribe((res) => {

				this.possibleTiers = res.result

				if (this.instruction[rang] && this.instruction.possibleTiers) {
					this.instruction.possibleTiers.forEach(element => {
						if (this.instruction[rang].instructeur.ID === element.ID)
							this.selectedTiers = element
					})
				}
				this.changeDetectorRef.detectChanges()
			})
			this.debounce.pipe(
				debounceTime(1000)
			).subscribe(search => {
				if (search.length > 0) {
					this.appService.getUsersByProfressions(professions, this.iddossier, search).subscribe((result) => {
						this.possibleTiers = result.result
						this.changeDetectorRef.detectChanges()
					})
				}

			})


			this.tabTransi = [];

			this.instructionList = [];
			for (let i=0; i<this.instruction.length; i++){
				let currentInstruction = this.instruction[i];
				let instruction = this.instruction[i];
				let dossier = this.dossiers[i];
				let libelle = currentInstruction.type.libelle;
				let libelleDemande = currentInstruction.demande.type.libelle;
				let canTransition = false;

				if (!this.procedureList[libelle])
					this.procedureList[libelle] = 
						{ 	
							"total": 0,
							"transition": 0
						};
				this.procedureList[libelle].total++;
				this.proceduresToCancel.push([currentInstruction.ID]);
				this.procedureTotal++;

				if (currentInstruction.transitions != null
					&& currentInstruction.transitions != undefined 
					&& currentInstruction.transitions.length == 1 ) 
				{
					for (let k=0; k<currentInstruction.transitions.length; k++) 
					{
						tab.push(currentInstruction.transitions[k].to.ID);
						currentInstruction.transitions[k].disabled=true;
					}
					this.tabTransi[currentInstruction.ID] = tab;
					this.options.push([currentInstruction.ID, tab]);
					this.proceduresToSend.push([currentInstruction.ID]);
					canTransition = true;
					tab = [];
					this.hasAtLeastOneInstructionNext = true;
					this.procedureList[libelle].transition++;
				}

				if (!this.instructionList[libelle])
					this.instructionList[libelle] = [];
				if (!this.instructionList[libelle][libelleDemande])
					this.instructionList[libelle][libelleDemande] = [];

				let data = {
					"id": instruction.ID,
					"nom": dossier.NOM,
					"prenom": dossier.PRENOM,
					"etape": instruction.etape.libelle,
					"transition": canTransition,
					"nextTransition": canTransition ? instruction.transitions[0].libelle : null,
				};
				this.instructionList[libelle][libelleDemande].push(data);
				this.refreshDialog();
			}

			if(this.options.length>0){

				this.instructionService.transitionsGroup(this.options).subscribe((res: JSONRpcResponse) => {
					if(res.result){
						for(let i=0;i<this.instruction.length;i++){
							if(this.instruction[i]!=undefined
							&& this.instruction[i].transitions !== undefined
							&& this.instruction[i].transitions.length == 1){
								for(let k=0;k<this.instruction[i].transitions.length;k++) {

									if (res.result[this.instruction[i].transitions[k].to.ID]!=undefined 
									&& Array.isArray(res.result[this.instruction[i].transitions[k].to.ID])){
										this.instruction[i].transitions[k].demandes=res.result[this.instruction[i].transitions[k].to.ID][0];
										this.etape.push(this.instruction[i].transitions[k]);
									}
									this.instruction[i].transitions[k].disabled=false;
									
								}
								this.changeDetectorRef.detectChanges()
							}
						}
					}
				})
			}
		} 
	}


	displayAutoSelectListInstru(key?: any): string | undefined {
		let selected
		if (this.possibleTiers) {
			
			this.possibleTiers.forEach((select) => {
				if (key && select.ID === key.ID)
					selected = select
			})
		}
		return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : '') : undefined
	} 
	
	updateInstructeurToUser(to_me:boolean=true){
		let toConfirm = true;
		let nbInstru:any = this.instruction.length;
		let libInstructeur:string; 

		if(to_me == false){
			if(this.selectedInstructeur == undefined){
				toConfirm = false;
			}
		} else {
			this.possibleTiers.forEach(tiers => {
				if (tiers.ID === this.user) {
					this.selectedInstructeur = tiers;
				}
			});
		}
		libInstructeur = this.selectedInstructeur.NOM +' '+	this.selectedInstructeur.PRENOM;
		
		if(toConfirm == true){
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data : {
					libelle : "Etes-vous sûr de vouloir affecter "+nbInstru+" procédure(s) à l'utilisateur "+ libInstructeur + " ?"
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if(res === "true"){ 
					this.instruction.comment= String(this.comment);
					this.instruction.titre=String(this.title);
					// let ins=this.user;
					// if (!to_me)
					// 	ins =this.selectedInstructeur;
						
					let dataReturn = {
						instructeur: this.selectedInstructeur,
						titre: String(this.title),
						comment: String(this.comment)
					}
					this.dialogRef.close(dataReturn);
				}
			});
		} else {
			console.log("Aucun utilisateur selectionné")
		}
		
	}

	updateInstructeurAuto()
	{
		const confDialogRef = this.dialog.open(ConfirmComponent, {
			data : {
				libelle : "Etes-vous sûr de vouloir affecter " + this.instruction.length + 
				" procédure(s) automatiquement ?"
			}
		});
		confDialogRef.afterClosed().subscribe(res => {
			if(res === "true"){ 
				this.instruction.comment= String(this.comment);
				this.instruction.titre=String(this.title);
					
				let dataReturn = {
					auto: true,
					instructeur: null,
					titre: String(this.title),
					comment: String(this.comment)
				}
				this.dialogRef.close(dataReturn);
			}
		});
	}

	changeEtape(action) {
		let libelle = "Êtes-vous sûr de vouloir ";
		let cancel = false;
		let resultArray = this.proceduresToSend;
		switch (action) {
			case "next":
				libelle += "modifier " + resultArray.length + " procédure(s) sur " + this.procedureTotal;
				break;
			case "stop":
				cancel = true;
				resultArray = this.proceduresToCancel;
				libelle += "stopper "+resultArray.length+" procédure(s) sur " + this.procedureTotal;
				break;
		}

		if (resultArray.length > 0) {
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data : {
					libelle : libelle
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if(res === "true"){
	
					let instruID:any = [];
	
					for(let i=0;i<resultArray.length;i++){
						if(resultArray[i])
							instruID.push(resultArray[i][0])
					}
	
					let dataReturn = {
						tabID:instruID,
						transition_demande_type: [],
						titre: String(this.title),
						comment: String(this.comment),
						etape: this.etape,
						cancel: cancel
					}
	
					for(let i=0;i<this.etape.length;i++){
						if(this.etape[i].demandes!=undefined 
						&& this.etape[i].demandes 
						&& this.etape[i].demandes.demande_type 
						&& this.etape[i].demandes.demande_type.length>0) {						
							dataReturn.transition_demande_type[i] = this.etape[i].demandes.demande_type 
						}
					}
					this.dialogRef.close(dataReturn)
				}
			})
		}
	}

	// cancelInstruction() {

	// 	let toConfirm = true;
	// 	if(toConfirm){
	// 		const confDialogRef = this.dialog.open(ConfirmComponent, {
	// 			data : {
	// 				libelle : "Etes-vous sûr de vouloir stopper "+this.instruction.length+" procédure(s)"
	// 			}
	// 		});
	// 		confDialogRef.afterClosed().subscribe(res => {
	// 			if(res === "true"){
	// 				this.dialogRef.close("Cancel");
	// 			}
	// 		});
	// 	}
	// }

	addProcedure(id, isTransition) {
		if (isTransition) {
			let index = this.getIndexFromArray(this.proceduresToSend, [id])
			if (!index && index != 0) {
				this.proceduresToSend.push([id]);
			} else {
				this.proceduresToSend.splice(index, 1);
			}
		}
		let index = this.getIndexFromArray(this.proceduresToCancel, [id])
		if (!index && index != 0) {
			this.proceduresToCancel.push([id]);
		} else {
			this.proceduresToCancel.splice(index, 1);
		}
		this.refreshDialog();
	}

	getIndexFromArray(array, value) {
		let hash = {};
		for(let i = 0; i < array.length; i++) {
			hash[array[i]] = i;
		}
		if (hash.hasOwnProperty(value)) {
			return hash[value];
		}
		return null;
	}
}
